<template>
  <div class="cities-city-card-skeleton-item">
    <SkeletonItem skeleton-class="cities-city-card-skeleton-item__image-container" :is-animated="animate" />
    <SkeletonItem skeleton-class="cities-city-card-skeleton-item__title" :is-animated="animate" />
    <SkeletonItem skeleton-class="cities-city-card-skeleton-item__counter" :is-animated="animate" />
  </div>
</template>

<script lang="ts" setup>
import { SkeletonItem } from '@experience/core-skeleton-lib';

withDefaults(defineProps<{ animate?: boolean }>(), { animate: false });
</script>

<style lang="scss" scoped>
.cities-city-card-skeleton-item {
  color: var(--alias-color-text-default);
  text-decoration: none;
}

.cities-city-card-skeleton-item__image-container {
  aspect-ratio: 1/1;
  border-radius: var(--alias-radius-16);

  @include adaptivity.mobile {
    border-radius: var(--alias-radius-12);
  }
}

.cities-city-card-skeleton-item__title {
  --height: var(--global-typography-size-400);
  --space: calc((var(--global-typography-line-height-400) - var(--height)) / 2);

  width: 90%;
  height: var(--height);
  margin: calc(var(--alias-space-4) + var(--space)) 0 var(--space);
  border-radius: var(--alias-radius-8);
}

.cities-city-card-skeleton-item__counter {
  --height: var(--global-typography-size-300);

  width: 80%;
  height: var(--height);
  margin-top: calc(var(--global-typography-line-height-200) - var(--height));
  border-radius: var(--alias-radius-6);
}
</style>
